'use client';



import { useLanguage } from '../../../context/LanguageContext';

export default function StepNavigation({
  currentStep,
  maxSteps,
  onNext,
  onPrevious,
  isLoading,
}) {
  const { translate } = useLanguage();

  return (
    <div className="flex justify-between gap-4 mt-8">
      <button
        type="button"
        onClick={onPrevious}
        disabled={currentStep === 1 || isLoading}
        className="px-8 py-2 border border-gray-300 rounded-lg text-white font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-500"
      >
        {translate("auth.navigation.previous")}
      </button>
      <button
        type="button"
        onClick={onNext}
        disabled={isLoading}
        className="px-8 py-2 bg-primary hover:bg-primary-dark text-white font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center min-w-[120px]"
      >
        {isLoading ? (
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
            {currentStep === maxSteps ? translate("auth.signup.saving") || "Saving..." : translate("auth.navigation.next")}
          </div>
        ) : (
          currentStep === maxSteps ? translate("auth.navigation.submit") : translate("auth.navigation.next")
        )}
      </button>
    </div>
  );
}
